import { ContentIntro } from './intro';

/**
 * Model definition for S-Cert
 */
export interface ContentSCert {
  __component: 'content.s-cert';
  id: string;
  intro?: ContentIntro;
  feedType: 'public' | 'archive';
}

export function isContentSCert(obj: { __component?: string }): obj is ContentSCert {
  return obj.__component === 'content.s-cert';
}
